import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @ts-ignore
import Img1 from '../assets/1.png';
// @ts-ignore
import Zafflo from '../assets/fav.png';
// @ts-ignore
import LoginBG from '../assets/loginBG.png'
//@ts-ignore
// import LoginBG from '../assets/13783.jpg'
import {useAuth} from '../state/AuthContext'
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import eye and eye-off icons
import { ToastContainer } from 'react-toastify';


const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<any>({});
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  useEffect(() => {
      const isUserLoggedIn = localStorage.getItem("email");
      //console.log("is user logged in", isUserLoggedIn)
  },[])

  const validate = () => {
    const errors: any = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      errors.email = 'Email is required';
    } else if (!emailRegex.test(email)) {
      errors.email = 'Enter a valid email';
    }

    if (!password) {
      errors.password = 'Password is required';
    } else if (password.length < 6) {
      errors.password = 'Password must be at least 6 characters';
    }

    return errors;
  };

  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try{
        setIsLoading(true);
        await login(email, password, navigate)
      }
      catch(err: any){
        //console.log('login error', err)
      }finally {
        setIsLoading(false);

      }
      // setTimeout(() => {
      //   setIsLoading(false);
      //   navigate('/user');
      // }, 2000); // Simulate a 2-second loading time
     
    
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#0b3a28] relative overflow-hidden">
      {/* Background Pattern */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <img
        className="absolute inset-0 z-0 bg-cover bg-center opacity-20 h-full w-full hidden sm:block"
       src={LoginBG} // Subtle dark pattern
       alt="Login Background"

      />

      {/* Login Container */}
      <div className=" flex flex-col md:flex-row items-center bg-white shadow-2xl rounded-2xl overflow-hidden w-full max-w-5xl mx-4 transform transition-all duration-500 hover:scale-[1.02] sm:hover:scale-105 z-10">
        {/* Image Section */}
        <div className="md:w-1/2 p-8 hidden md:block">
          <img
            src={Img1}
            alt="Login Illustration"
            className="h-full w-full object-cover rounded-lg"
          />
        </div>

        {/* Login Form Section */}
        <div className="w-full md:w-1/2 px-4 py-5 sm:p-8">
          <div className="flex flex-col items-center">
            <img src={Zafflo} alt="Logo" className="h-24 w-24 object-contain" />
            <h1 className="text-3xl font-bold mb-2 text-gray-800 font-[Lato]">
              Welcome Back!
            </h1>
            <p className="text-gray-600 text-center mb-6 font-[roboto]">
              Sign in to continue to your account
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="email"
              >
                Email*
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full px-4 py-3 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#0b3a28] transition-all duration-300 ${
                  errors?.email ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Enter your email"
              />
              {errors?.email && (
                <p className="text-red-500 text-sm mt-1">{errors?.email}</p>
              )}
            </div>
            {/* <div>
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="password"
              >
                Password*
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full px-4 py-3 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#0b3a28] transition-all duration-300 ${
                  errors?.password ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Enter your password"
              />
              {errors?.password && (
                <p className="text-red-500 text-sm mt-1">{errors?.password}</p>
              )}
            </div> */}

        <div className="relative">
              <label
                className="block text-gray-700 text-sm font-bold mb-2"
                htmlFor="password"
              >
                Password*
              </label>
              <input
                type={showPassword ? 'text' : 'password'} // Toggle input type
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full px-4 py-3 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#0b3a28] transition-all duration-300 ${
                  errors?.password ? 'border-red-500' : 'border-gray-300'
                }`}
                placeholder="Enter your password"
              />
              {/* Eye icon to toggle password visibility */}
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 mt-7"
              >
                {showPassword ? <FaEye className="text-gray-500" /> : <FaEyeSlash className="text-gray-500" /> }
              </button>
            </div>

            {/*  */}
            <button
              type="submit"
              className="w-full bg-[#6cbb23] hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 flex items-center justify-center"
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="loader border-t-transparent border-4 border-white rounded-full w-5 h-5 animate-spin"></span>
              ) : (
                'Login'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;